import React, { Component } from "react";

/*import DEBUG from "config/debug.js"*/

//Import Page Css
import "../assets/pages/css/login-4.css";

//Import Logo
/*import Logo from '../assets/global/img/AssetVault_logo.jpg';*/

//Import react-redux
import { connect } from "react-redux";

//Presenter Layer
import PresentationLayer from "../../user/presenter.js";

//Import Message config
import MessageProperties from "../../config/message.js";

// Import Toast src: https://fkhadra.github.io/react-toastify/
import { ToastContainer, toast } from "react-toastify";

import getLogoBranding from "utils/getLogoBranding.js";

class LoginScreen extends Component {
  constructor(props) {
    super(props);

    //Check Session
    if (
      this.props.UserReducer.is_auth &&
      !this.props.UserReducer.props.is_superuser
    ) {
      this.props.history.push("/home"); //redirect to home page
    } else if (
      this.props.UserReducer.is_auth &&
      this.props.UserReducer.props.is_superuser
    ) {
      this.props.history.push("/su/tenant-list"); //redirect to superuser
    }

    //Init State
    this.state = {
      user: "",
      password: "",
      notify: "",
      toasid: null,
      seconds: 0
    };

    //Bind Event
    this.__OnUserChanged__ = this.__OnUserChanged__.bind(this);
    this.__OnPasswordChanged__ = this.__OnPasswordChanged__.bind(this);
    this.__Login__ = this.__Login__.bind(this);
    this.__RenderLoginButton__ = this.__RenderLoginButton__.bind(this);
    this.__ValidateForm__ = this.__ValidateForm__.bind(this);

    this.__OnSuccess__ = this.__OnSuccess__.bind(this);
  }

  // this for Prevent duplicate toast
  preventToast(tipe, msg) {
    switch (tipe) {
      case "warning":
        if (!toast.isActive(this.state.toasid)) {
          this.setState.toasid = toast.warning(msg);
        }
        break;
      case "error":
        if (!toast.isActive(this.state.toasid)) {
          this.setState.toasid = toast.error(msg);
        }
        break;
      case "success":
        if (!toast.isActive(this.state.toasid)) {
          this.setState.toasid = toast.success(msg);
        }
        break;
      default:
        if (!toast.isActive(this.state.toasid)) {
          this.setState.toasid = toast(msg);
        }
        break;
    }
  }

  __GenerateRequestParameter__() {
    return {
      data: this.state,
      UserReducer: this.props.UserReducer,
      RunRedux: this.props.RunRedux,
      onfailed: this.__OnFailed__,
      onsuccess: this.__OnSuccess__,
      history: this.props.history
    };
  }
  __OnSuccess__(history){
    history.push("/");
  }

  __OnFailed__(response) {
    if (response.error_description === "Invalid credentials given.") {
      toast.error(MessageProperties.ERROR.LOGIN.LOGIN_FAILED_FALSE_CREDENTIAL);
      return;
    }
    else if (response.error_description === 'You Login use Lite version') {
      toast.error(
        'You Login use Lite version'
      );
    }
    toast.error(
      MessageProperties.ERROR.LOGIN.LOGIN_FAILED +
        " ,Your account is disabled! Please contact Administrator"
    );
  }

  __ValidateForm__() {
    if (this.state.user.trim() === "") {
      this.preventToast("warning", MessageProperties.ERROR.LOGIN.USER_EMPTY);
      return false;
    } else if (this.state.password.trim() === "") {
      this.preventToast(
        "warning",
        MessageProperties.ERROR.LOGIN.PASSWORD_EMPTY
      );
      return false;
    }
    return true;
  }

  __Login__() {
    if (!this.__ValidateForm__()) {
      return;
    }

    this.setState({ in_auth: true });
    PresentationLayer.UserAuth(this.__GenerateRequestParameter__());
  }

  __OnUserChanged__(event) {
    this.setState({ user: event.target.value });
  }

  __OnPasswordChanged__(event) {
    this.setState({ password: event.target.value });
  }

  __RenderLoginButton__() {
    if (this.props.UserReducer.in_auth) {
      return (
        <button type="button" className="btn btn-primary px-4" disabled>
          <i className="fa fa-spinner fa-pulse fa-fw"></i>
        </button>
      );
    } else {
      return (
        <button
          type="submit"
          className="btn btn-primary px-4"
          onClick={() => this.__Login__()}
        >
          Login
        </button>
      );
    }
  }

  handleKeyPress(e) {
    if (e.key === "Enter" && e.shiftKey === false) {
      e.preventDefault();

      if (e.currentTarget.name === "username") {
        // if username null
        if (e.currentTarget.value.trim() === "") {
          this.preventToast(
            "warning",
            MessageProperties.ERROR.LOGIN.USER_EMPTY
          );
          /*this.c*/
        } else {
          this.password.focus();
        }
      } else {
        this.__Login__();
      }
    }
  }

  componentDidMount() {
    this.username.focus();
  }
  render() {
    return (
      <div className="app flex-row align-items-center">
        <ToastContainer
          position="top-center"
          type="default"
          autoClose={5000}
          hideProgressBar={true}
          newestOnTop={false}
          closeOnClick
          pauseOnHover
        />
        <div className="container">
          <div className="row justify-content-center">
            <div className="col-md-8">
              <div className="card-group mb-0">
                <div className="card p-4">
                  <div className="card-block">
                    <h1>Login</h1>
                    <p className="text-muted">Sign In to your account</p>
                    <div className="input-group mb-3">
                      <span className="input-group-addon">
                        <i className="icon-user"></i>
                      </span>
                      <input
                        ref={input => {
                          this.username = input;
                        }}
                        className="form-control"
                        placeholder="Username"
                        type="text"
                        autoComplete="off"
                        name="username"
                        value={this.state.user}
                        onKeyPress={e => {
                          this.handleKeyPress(e);
                        }}
                        onChange={this.__OnUserChanged__}
                      />
                    </div>
                    <div className="input-group mb-4">
                      <span className="input-group-addon">
                        <i className="icon-lock"></i>
                      </span>
                      <input
                        ref={input => {
                          this.password = input;
                        }}
                        type="password"
                        className="form-control"
                        placeholder="Password"
                        autoComplete="off"
                        name="password"
                        value={this.state.password}
                        onKeyPress={e => {
                          this.handleKeyPress(e);
                        }}
                        onChange={this.__OnPasswordChanged__}
                      />
                    </div>
                    <div className="row">
                      <div className="col-6">
                        {this.__RenderLoginButton__()}
                      </div>
                      <div className="col-6 text-right">
                        <button
                          type="button"
                          className="btn btn-link px-0"
                          onClick={() => this.props.history.push("/forgot")}
                        >
                          Forgot password?
                        </button>
                      </div>
                    </div>
                  </div>
                </div>
                <div
                  className="card card-inverse  py-5 d-md-down-none"
                  style={{ width: "44%" }}
                >
                  <div className="card-block text-center">
                    <div>
                      <img
                        src={getLogoBranding(
                          "login",
                          this.props.TenantReducer.login
                        )}
                        alt="assetvault-logo"
                        width="150"
                      />
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    );
  }
}

const mapStateToProps = state => {
  return {
    UserReducer: state.UserReducer,
    TenantReducer: state.TenantReducer
  };
};

const mapDispatchToProps = dispatch => {
  return {
    RunRedux: data => {
      dispatch(data);
    }
  };
};

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(LoginScreen);



// WEBPACK FOOTER //
// ./src/App/views/templates/login.js